import { lazy } from "react";

const LoginPage = lazy(() => import(/* webpackChunkName: `LoginPage` */ `./LoginPage.js`));

//SEPA
const Sepa = lazy(() => import(`./PaymentHub/SDD/BulkSDD.js`));
const SepaStatistics = lazy(() => import(`./PaymentHub/SepaStatistics.js`));
const Bulk = lazy(() => import(`./PaymentHub/SDD/BulkSDD.js`));
const DebitSdd = lazy(() => import(`./PaymentHub/SDD/DebitSdd.js`));
const BulkSCT = lazy(() => import(`./PaymentHub/SCT/BulkSCT.js`));;
const Sct = lazy(() => import(`./PaymentHub/SCT/Sct.js`));
const DownloadSdd = lazy(() => import(`./PaymentHub/SDD/DownloadSDD.js`));
const DownloadSct = lazy(() => import(`./PaymentHub/SCT/DownloadSCT.js`));

//Signature
const ApprovalSct = lazy(() => import(`./DigitalSignature/ApprovalBulkSCT.js`));
const SignatureSct = lazy(() => import(`./DigitalSignature/SignBulkSCT.js`));
const SignatureUser = lazy(() => import(`./DigitalSignature/SignatureUserManagerContainer.js`));
const SignatureProfiles = lazy(() => import(`./DigitalSignature/SignatureProfileManagerContainer.js`));
//Aggiungere pagine di firma e gestione utenti e profili

const Configuration = lazy(() => import(`./PaymentHub/Configuration/Configuration.js`));

export {
    LoginPage, SepaStatistics, Sct, Sepa, Bulk, DebitSdd, DownloadSdd, BulkSCT, DownloadSct, ApprovalSct, SignatureSct, SignatureUser, SignatureProfiles, Configuration
};
